import type { OwaHeaderPaneProps } from "owa-header-types";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "HeaderRewardsPane"*/ "./lazyIndex"), { name: "HeaderRewardsPane" });

export const RewardsPane: LazyComponent<OwaHeaderPaneProps, unknown, void> = createLazyComponent(lazyModule, module => module.RewardsPane);
